module.exports = __webpack_public_path__ + "img/QR.f77fb1a0.png";